import React from 'react';

import {useViewerInfo} from '../../../../../../common/hooks/useViewerInfo';
import {WaveLoader} from '../../../../../Loaders/WaveLoader';
import {CallsPageLoadViewWithUser} from './CallsPageLoadViewWithUser';

type CallsPageLoadViewProps = {
  entity: string;
  project: string;
  tab: string;
  view?: string;
};

export const CallsPageLoadView = ({
  entity,
  project,
  tab,
  view,
}: CallsPageLoadViewProps) => {
  const {loading: loadingUserInfo, userInfo} = useViewerInfo();

  if (loadingUserInfo) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          zIndex: 1,
        }}>
        <WaveLoader size="huge" />
      </div>
    );
  }

  return (
    <CallsPageLoadViewWithUser
      entity={entity}
      project={project}
      tab={tab}
      view={view}
      userInfo={userInfo}
    />
  );
};
